import type { IconSvgObject } from './types';

const WorkflowSquare09Icon: IconSvgObject = [
  ["path", { d: "M9 7V3C9 2.44772 8.55228 2 8 2H4C3.44772 2 3 2.44772 3 3V7C3 7.55228 3.44772 8 4 8H8C8.55228 8 9 7.55228 9 7Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M9 21V17C9 16.4477 8.55228 16 8 16H4C3.44772 16 3 16.4477 3 17V21C3 21.5523 3.44772 22 4 22H8C8.55228 22 9 21.5523 9 21Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M21 7V3C21 2.44772 20.5523 2 20 2H16C15.4477 2 15 2.44772 15 3V7C15 7.55228 15.4477 8 16 8H20C20.5523 8 21 7.55228 21 7Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M6 8V16", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }],
  ["path", { d: "M6 12H16C17.1046 12 18 11.1046 18 10V8", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "4" }]
];

export default WorkflowSquare09Icon;
